<div class="modal-window__header">
  <div class="modal-window__title">
    {{ "localization.addtranslation" | translate }}
  </div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="submitResult({ code: code.value, translation: name.value })"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="code"
      class="c-form-label"
      >{{ "localization.key" | translate }}</label
    >
    <input
      #code="ngModel"
      ngModel
      id="code"
      name="code"
      class="c-input c-input--alpha"
      required />
    <div
      *ngIf="code.touched && code.errors?.required"
      class="c-form-alert">
      {{ "localization.keyrequirederror" | translate }}
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="name"
      class="c-form-label"
      >{{ "localization.value" | translate }}</label
    >
    <input
      #name="ngModel"
      ngModel
      id="name"
      name="name"
      class="c-input c-input--alpha"
      required />
    <div
      *ngIf="name.touched && name.errors?.required"
      class="c-form-alert">
      {{ "localization.valuerequirederror" | translate }}
    </div>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid">
      {{ "button.save" | translate }}
    </button>
  </div>
</form>
